import React, { useState, useEffect } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import * as bootstrap from "bootstrap";

import {
  mainDisclaimerHeaderContent,
  mainDisclaimerDataContent,
} from "../../data/mainDisclaimerDataContent";

const MainDisclaimerModal = () => {
  const [mainDisclaimerAccepted, setMainDisclaimerAccepted] = useState(false);
  const [showDiscModal, setShowDiscModal] = useState(false);

  const disclaimerAcceptedHandler = () => {
    localStorage.setItem("mainDisclaimerAccepted", "true");
    setMainDisclaimerAccepted(true);

    const modalEl = document.getElementById("landingDisclaimerModal");
    const modal =
      bootstrap.Modal.getInstance(modalEl) || new bootstrap.Modal(modalEl);
    modal.hide();

    setTimeout(() => {
      document.body.style.overflow = "auto";
    }, 300);
  };

  useEffect(() => {
    const accepted = localStorage.getItem("mainDisclaimerAccepted") === "true";
    setMainDisclaimerAccepted(accepted);
    if (!accepted) {
      setShowDiscModal(true);
    }
  }, []);

  useEffect(() => {
    if (showDiscModal) {
      const modalElement = document.getElementById("landingDisclaimerModal");
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }, [showDiscModal]);

  const showDisclaimerItemData = (item, ind) => {
    if (item.type === "para") {
      return (
        <div key={ind} className="mb-3">
          <div className="disclaimer-modal-sub-head">{item?.dataHeader}</div>
          {item?.content.length > 0 &&
            item?.content.map((val, i) => (
              <p className="disclaimer-modal-para" key={i}>
                {val}
              </p>
            ))}
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div
      className="modal fade disclaimer-modal"
      id="landingDisclaimerModal"
      tabIndex="-1"
      aria-labelledby="landingGameModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header"></div>
          <div className="modal-body" tabIndex="0">
            {mainDisclaimerHeaderContent &&
              mainDisclaimerHeaderContent.header && (
                <div className="modal-heading mb-0">
                  {mainDisclaimerHeaderContent.header}
                </div>
              )}
            {mainDisclaimerHeaderContent &&
              mainDisclaimerHeaderContent.lastUpdated && (
                <div className="modal-last-updated">
                  {mainDisclaimerHeaderContent.lastUpdated}
                </div>
              )}

            {!mainDisclaimerAccepted && (
              <>
                {mainDisclaimerHeaderContent &&
                  mainDisclaimerHeaderContent.disclaimerIntro && (
                    <p className="disclaimer-modal-para">
                      {mainDisclaimerHeaderContent.disclaimerIntro}
                    </p>
                  )}
                {mainDisclaimerDataContent.length > 0 &&
                  mainDisclaimerDataContent.map((item, i) =>
                    showDisclaimerItemData(item, i)
                  )}

                <div className="d-flex gap-2 disclaimer-border-top">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={disclaimerAcceptedHandler}
                  >
                    Accept
                  </button>
                  <div className="disclaimer-modal-note">
                    By clicking "Accept", you confirm that you've either read or
                    agree to read them later from our disclaimer page.
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainDisclaimerModal;
